import axiosInstance from '../axiosConfig';
import { generateBFFUrl } from '@/configs/apiEndPoints';
import {
  CHANGE_PROFILE_INFO,
  DELETE_PROFILE_INFO,
  GET_PROFILE_V2,
  UPDATE_PRIMARY_USERNAME,
  VERIFY_ADD_PROFILE_INFO,
  VERIFY_UPDATE_PROFILE_INFO,
} from '@/configs/ecom/apis';
import { GenericError } from '@/errors/GenericServerError';
import { AxiosResponse } from 'axios';
import { ERROR } from '@/configs/constants';
import { D365_USER_ID } from '@/constants/profileManagement';
import Cookies from '@/utils/cookie';

export const getProfileV2 = async (): Promise<any> => {
  let d365UserId = Cookies.get(D365_USER_ID);

  try {
    return await axiosInstance.get(generateBFFUrl(GET_PROFILE_V2), {
      params: {
        d365UserId: d365UserId ?? '',
      },
    });
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError(ERROR.GENERIC_MESSAGE, status, statusText, data);
  }
};

export const addProfileInfo = async (body: any): Promise<any> => {
  try {
    return await axiosInstance.post(generateBFFUrl(CHANGE_PROFILE_INFO), body);
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};

export const updateProfileInfo = async (body: any): Promise<any> => {
  try {
    return await axiosInstance.patch(generateBFFUrl(CHANGE_PROFILE_INFO), body);
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};
export const verifyAddProfileInfo = async (body: any): Promise<any> => {
  try {
    return await axiosInstance.post(generateBFFUrl(VERIFY_ADD_PROFILE_INFO), body);
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};

export const verifyUpdateProfileInfo = async (body: any): Promise<any> => {
  try {
    return await axiosInstance.post(generateBFFUrl(VERIFY_UPDATE_PROFILE_INFO), body);
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};

export const deleteProfileInfo = async (body: any): Promise<any> => {
  try {
    return await axiosInstance.post(generateBFFUrl(DELETE_PROFILE_INFO), body);
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};

export const updatePrimaryUsername = async (body: any): Promise<any> => {
  try {
    return await axiosInstance.patch(generateBFFUrl(UPDATE_PRIMARY_USERNAME), body);
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError('Something went wrong', status, statusText, data);
  }
};
